import { supabase } from './supabase';

export interface ReferrerInfo {
  user_id: string;
  full_name: string;
  email: string;
  referral_code: string;
  account_complete: boolean;
  lookup_method: 'code' | 'email' | 'phone';
}

export const referrerLookupService = {
  async findReferrerByContact(contactValue: string): Promise<ReferrerInfo | null> {
    if (!contactValue || contactValue.trim() === '') {
      return null;
    }

    try {
      const { data, error } = await supabase.rpc('find_referrer_by_contact', {
        contact_value: contactValue.trim(),
      });

      if (error) {
        console.error('Error finding referrer:', error);
        return null;
      }

      if (!data || data.length === 0) {
        return null;
      }

      return data[0] as ReferrerInfo;
    } catch (error) {
      console.error('Error in findReferrerByContact:', error);
      return null;
    }
  },

  async validateReferrerContact(
    contactValue: string,
    referrerId: string
  ): Promise<boolean> {
    try {
      const referrer = await this.findReferrerByContact(contactValue);

      if (!referrer) {
        return false;
      }

      return referrer.user_id === referrerId;
    } catch (error) {
      console.error('Error validating referrer contact:', error);
      return false;
    }
  },

  formatPhoneNumber(phone: string): string {
    const cleaned = phone.replace(/\D/g, '');

    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    } else if (cleaned.length === 11 && cleaned[0] === '1') {
      return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
    }

    return phone;
  },

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },

  isValidPhone(phone: string): boolean {
    const cleaned = phone.replace(/\D/g, '');
    return cleaned.length >= 10 && cleaned.length <= 11;
  },

  detectContactType(contact: string): 'email' | 'phone' | 'code' | 'unknown' {
    const trimmed = contact.trim();

    if (this.isValidEmail(trimmed)) {
      return 'email';
    }

    if (this.isValidPhone(trimmed)) {
      return 'phone';
    }

    if (/^[A-Z0-9]{6,10}$/i.test(trimmed)) {
      return 'code';
    }

    return 'unknown';
  },
};
